// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.pierwallet",
    name: "pier",
    homepage: "https://www.pierwallet.com",
    image_id: "cf3f0da1-40ec-4940-aebe-df075513d100",
    app: {
        browser: "https://www.pierwallet.com",
        ios: "https://apps.apple.com/lb/app/id1613187762",
        android: "https://play.google.com/store/apps/details?id=one.nobank.app",
        mac: "",
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://pierwallet.xyz/wc",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map